import { OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import DealPipeline from '@/data/models/domain/deals/DealPipeline'

@OrmModel(modelNames.DEAL_PIPELINE_ARCHIVED)
export default class DealPipelineArchived extends DealPipeline {
  @StringField()
  public override archivedAt: string
}
